import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/store';
import handleRegisterAsyncData, {
  handleRegisterCountAsyncData,
} from 'global-components/register/OhsModuleRegisterUtils';
import { OhsQrCodeViewPresets, QrCodeListsRecordState } from 'qr-code/models/OhsQrCodeModels';

import { fetchQrCodeListsAsync, fetchQrCodeListsCountAsync } from './OhsQrCodeActions';

const defaultQrCodeLists = {
  items: [],
  pagination: {
    page: 0,
    totalPages: 0,
    next: '',
  },
};
const initialState: QrCodeListsRecordState = {
  isLoading: false,
  qrCodeLists: defaultQrCodeLists,
  allocatedList: null,
  currentPage: 1,
  currentViewPreset: OhsQrCodeViewPresets.View1QrCodeList,
};

export const qrCodeSlice = createSlice({
  name: 'qrCode',
  initialState,
  reducers: {
    setCurrentRegisterPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setQrCodeIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setViewPreset: (state, action: PayloadAction<OhsQrCodeViewPresets>) => {
      state.currentViewPreset = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQrCodeListsAsync.pending, (state) => {
        state.isLoading = true;
        state.qrCodeLists = defaultQrCodeLists;
      })
      .addCase(fetchQrCodeListsAsync.fulfilled, (state, action) => {
        if (action.payload) {
          const qrCodeList = handleRegisterAsyncData(action.payload, 'qrCodeListtotalPages');
          state.isLoading = false;
          state.qrCodeLists = qrCodeList;
          state.currentPage = qrCodeList.pagination.page ?? 1;
        }
      })
      .addCase(fetchQrCodeListsAsync.rejected, (state) => {
        state.qrCodeLists = defaultQrCodeLists;
      })
      .addCase(fetchQrCodeListsCountAsync.fulfilled, (state, action) => {
        const qrCodeListCountResult: any = action.payload;
        if (state.qrCodeLists && qrCodeListCountResult) {
          const countQrCodeLists = handleRegisterCountAsyncData(
            qrCodeListCountResult,
            state.qrCodeLists,
            'qrCodeListtotalPages'
          );
          state.qrCodeLists = countQrCodeLists;
        }
      });
  },
});

// Memoized Selectors
const qrCodeState = (state: RootState) => state.qrCode;
export const getOhsQrCodeLists = createSelector([qrCodeState], (qrCode) => qrCode);

export const { setCurrentRegisterPage, setQrCodeIsLoading, setViewPreset } = qrCodeSlice.actions;
export const qrCodeModuleReducer = qrCodeSlice.reducer;
